import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import ProductRR from "./views/ProductRR.vue";
import ProductRRIntense from "./views/ProductRRIntense.vue";
import ProductRREyes from "./views/ProductRREyes.vue";
import EightYear from "./views/EightYear.vue";
import ByMedik8 from "./views/ByMedik8.vue";

Vue.use(Router);

export default new Router({
  mode:'history',
  base:'retinoate',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/youth-activating-cream",
      name: "rr",
      component: ProductRR
    },
    {
      path: "/youth-activating-cream-intense",
      name: "rr-intense",
      component: ProductRRIntense
    },
    {
      path: "/rejuvenating-eye-system",
      name: "rr-eyes",
      component: ProductRREyes
    },
    {
      path: "/8-year-masterpiece",
      name: "masterpiece",
      component: EightYear
    },
    {
      path: "/by-medik8",
      name: "bymedik8",
      component: ByMedik8
    }
  ]
});
